import { useState } from 'react';

import { Button } from '../../../../cdl/Button/Button';
import { translate } from '../../../../common/helpers/translate.helper';
import { EditPresetsOverlay } from '../../../VesselConsumptionPresets/EditPresetsOverlay';

interface EditPresetsButtonProps {
    customerId: string;
    vesselId: string;
}

export const EditPresetsButton = (props: EditPresetsButtonProps) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button onClick={() => setOpen(true)}>{translate('consumption.editPresets.title')}</Button>

            {open ? (
                <EditPresetsOverlay
                    vesselId={props.vesselId}
                    customerId={props.customerId}
                    onClose={() => setOpen(false)}
                />
            ) : null}
        </>
    );
};
